class DocumentStatusOverTime {
  getDocumentStatusList() {
    const documentsStatusList = [
      { id: 1, name: 'Uploaded' },
      { id: 2, name: 'Ready for approval' },
      { id: 3, name: 'Approved' },
      { id: 4, name: 'Rejected' }
    ];
    return documentsStatusList;
  }

  getLastMonths(lastN: any) {
    const d = new Date();
    d.setMonth(d.getMonth() - (lastN - 1));
    const monthsList = [];
    d.setDate(1);
    for (let i = 0; i < lastN; i++) {
      monthsList.push({
        tmf_doc_updated_year: d.getFullYear(),
        tmf_doc_updated_month: d.getMonth() + 1
      });
      d.setMonth(d.getMonth() + 1);
    }
    return monthsList;
  }
}
export default DocumentStatusOverTime;
